import { render, staticRenderFns } from "./HeaderComponentBrick.vue?vue&type=template&id=0c7bc8d8&scoped=true&"
import script from "./HeaderComponentBrick.vue?vue&type=script&lang=js&"
export * from "./HeaderComponentBrick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7bc8d8",
  null
  
)

export default component.exports